<template >
  <div class="component-container">
    <app-navigation v-if="!($props.onlyMaps)"></app-navigation>
    <div v-if="!($props.onlyMaps)" class="main-div" :class="formState.invalidShake?'invalid':''">
      <div
        v-if="errors.length && formState.attempted && (!formState.loading)"
        class="col-12 col-sm-12"
      >
        <b class="w-100">Please correct the following error(s):</b>
        <ul>
          <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>

      <form class="email-form">
        <fieldset :disabled="formState.loading" class="p-0 col-12 col-sm-12" v-if="newEmail==null">
          <legend>Existing Emails</legend>
          <div class="row" v-for="(email,index) in fetchedEmails" :key="index">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Email</label>
              <input
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="email.value"
                disabled
                v-if="!email.editMode"
              />
              <input
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="email.newValue"
                v-if="email.editMode"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <button
                type="button"
                v-on:click="email.editMode?changeEmail(email.value,email.newValue):enterEditMode(email)"
                class="btn btn-info"
                :disabled="formState.loading"
              >{{email.editMode?"Confirm Edit":"Edit"}}</button>
              <button
                v-if="email.editMode"
                type="button"
                v-on:click="exitEditMode()"
                class="btn btn-danger"
                :disabled="formState.loading"
              >CancelEdit</button>
              <button
                v-if="!email.editMode"
                type="button"
                v-on:click="deleteEmail(email.value)"
                class="btn btn-danger"
                :disabled="formState.loading"
              >Delete Email</button>
            </div>
          </div>
        </fieldset>

        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newEmail!=null)"
        >
          <legend>Add New Email</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Email</label>
              <input
                v-on:input="checkForm"
                v-on:keydown.enter.prevent="saveNewEmail"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newEmail"
                placeholder="ex. abc@xyz.com"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <button
                type="button"
                v-on:click="saveNewEmail"
                class="btn btn-danger"
                :disabled="formState.loading"
              >Add</button>
              <button
                type="button"
                v-on:click="cancelNewEmail"
                class="btn btn-danger"
                :disabled="formState.loading"
              >Cancel</button>
            </div>
          </div>
        </fieldset>
        <div class="col-12 col-sm-12" v-if="newEmail==null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="addNewEmail()"
            class="m-0 btn btn-success"
          >Add New Email</button>
        </div>
      </form>
    </div>
    
    <div v-if="$props.onlyMaps" class="main-div" style="width:100%" :class="formState.invalidShake?'invalid':''">
      <hr v-if="mapsIframe!=null && newEmail == null" />
      <div class="form-group col-12 col-sm-12" v-if="mapsIframe!=null && newEmail == null">
        <label class="pl-0 col-12 col-sm-4" for="name">Google maps iframe</label>
        <input
          v-on:input="checkForm"
          class="form-control col-12 col-sm-8"
          required
          type="text"
          v-model="mapsIframe.value"
          id="name"
          placeholder="ex. https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2965.0824050173574!2d-93.63905729999999!3d41.998507000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sWebFilings%2C+University+Boulevard%2C+Ames%2C+IA!5e0!3m2!1sen!2sus!4v1390839289319"
        />
        <div class="form-group col-12 col-sm-12 m-1">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="commitChangesToIframe()"
            class="btn btn-info"
          >Confirm Changes To Maps Link </button>
        </div>
      </div>
      <hr v-if="mapsIframe!=null" />
      
    </div>
  </div>
</template>



<!-- email Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;
  div {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .--centered-block {
    margin: 0 auto;
  }
}

//  0.82s
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";

import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  email: "emailsCRUD",
  props: ["onlyMaps"],
  data() {
    return {
      mapsIframe: null,
      fetchedEmails: [],
      newEmail: null, // If add email button is pressed, this will be an object with a email, a answer and a email_en.
      errors: [], // Form's errors
      editedEmail: null,
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false
      } // Object Determining the Form's state
    };
  },
  watch: {
    newEmail: function() {
      this.checkForm();
    },
    "editedEmail.newValue": function() {
      this.checkForm();
    }
  },
  mounted() {
    this.fetchAllEmailsAndIframe();
  },
  methods: {
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
    addNewEmail() {
      this.newEmail = "";
    },
    cancelNewEmail() {
      this.newEmail = null;
    },
    resetAllEmailObjects() {
      this.fetchedEmails.forEach(em => {
        em.editMode = false;
        em.newValue = em.value;
      });
    },
    enterEditMode(emailToEdit) {
      this.resetAllEmailObjects();
      emailToEdit.editMode = true;
      this.editedEmail = emailToEdit;
    },
    exitEditMode() {
      this.resetAllEmailObjects();
      this.editedEmail = null;
    },
    // Partially resets the form
    partiallyResetForm: function() {
      this.fetchedEmails = [];
      this.newEmail = null; // If add email button is pressed, this will be an object with a email, a answer and a email_en.
      this.errors = []; // Form's errors
      this.editedEmail = null;
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false
      };
    },
    checkForm: function() {
      const emailRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      this.errors = [];
      if (!this.mapsIframe.value)
        this.errors.push("Google Maps iframe is required.");
      if (
        this.mapsIframe &&
        this.mapsIframe.value &&
        this.mapsIframe.value.length < 5
      )
        this.errors.push("Enter a valid Google Maps iframe");
      if (this.newEmail) {
        if (this.newEmail == "") this.errors.push("Email is required");
        if (!emailRegex.test(this.newEmail))
          this.errors.push("Email is invalid");
      } else if (this.editedEmail && this.editedEmail.editMode) {
        if (this.editedEmail.newValue == "")
          this.errors.push("Email is required");
        if (!emailRegex.test(this.editedEmail.newValue))
          this.errors.push("Email is invalid");
      }
    },
    fetchAllEmailsAndIframe() {
      this.formState.loading = true;
      return Promise.all([
        axios.post(`${herokuUrl}/dashboard/getAllContactEmails`, null, {
          headers: {
            Authorization: getCookie("user")
          }
        }),
        axios.get(`${herokuUrl}/dashboard/mapsIframe`, {
          headers: {
            Authorization: getCookie("user")
          }
        })
      ])
        .then(res => {
          res[0].data.contactEmails.forEach(element => {
            if (element != "")
              this.fetchedEmails.push({
                value: element,
                editMode: false,
                newValue: element
              });
          });
          this.mapsIframe = {value: res[1].data.value[0].value}
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "Emails fetching failed, " +
                err.response.data.message
            );
          }
          // window.location.reload();
        });
    },
    deleteEmail(emailToDelete) {
      if (confirm("Please confirm you want to DELETE the selected email")) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deleteContactEmail`,
            {
              email: emailToDelete
            },
            {
              headers: {
                Authorization: getCookie("user")
              }
            }
          )
          .then(() => {
            alert("email was deleted successfully");
            this.partiallyResetForm();
            this.fetchAllEmailsAndIframe();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected email " +
                  err.response.data.message
              );
            }
          });
      }
    },
    changeEmail(emailToEdit, newEmailValue) {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected email with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/editContactEmail`,
              { oldEmail: emailToEdit, newEmail: newEmailValue },
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("email was Edited successfully");
              this.partiallyResetForm();
              this.fetchAllEmailsAndIframe();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected email " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    commitChangesToIframe() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the Google maps Iframe with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .put(`${herokuUrl}/dashboard/updateMapsIframeSource`, this.mapsIframe, {
              headers: {
                Authorization: getCookie("user")
              }
            })
            .then(() => {
              alert("info was Edited successfully");
              this.partiallyResetForm();
              this.fetchAllEmailsAndIframe();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected info " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    saveNewEmail() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (confirm("Please confirm you want to Add a new email")) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/addNewContactEmail`,
              { email: this.newEmail },
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("email was Added successfully");
              this.partiallyResetForm();
              this.fetchAllEmailsAndIframe();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem adding the new email " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
